


















import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { debounce } from 'quasar'
import Vditor from 'vditor'
import "vditor/src/assets/scss/index.scss"

@Component
export default class MarkdownEditor extends Vue {
  ready = false
  focusable = false
  content!: Vditor
  observer!: MutationObserver
  observerPreviousValue = ''
  sourceEdit = false

  @Prop({ default: '' })
  readonly value!: string

  @Prop({ default: '' } )
  readonly placeholder!: string

  @Prop({ default: false })
  readonly toolbar!: boolean | Json[]

  get options () {
    return {
      theme: 'dark',
      mode: this.sourceEdit ? 'sv' : 'ir',
      preview: {
        maxWidth: undefined,
        mode: 'editor',
        math: {
          engine: 'KaTeX',
          // engine: 'MathJax',
          // macros: { packages: {'[+]': ['mhchem']} }
        }
      },
      width: '100%',
      lang: 'en_US',
      placeholder: this.placeholder,
      tab: '\t',
      toolbar: (["bold", "italic", "strike", "link", "|", "list", "ordered-list", "check", "outdent", "indent", "|", "quote", "line", "code", "inline-code", "table"] as Array<string|Json>).concat(this.toolbar && this.toolbar !== true ? this.toolbar : []),
      toolbarConfig: {
        hide: this.$q.screen.lt.sm ? true : !this.toolbar || this.sourceEdit
      },
      cache: {
        enable: false,
      },
      focus: () => {
        if (!this.focusable) {
          this.content.blur()
        }
      },
      after: () => {
        this.ready = true
        this.update(this.value)
        this.observer = new MutationObserver((mutationsList) => {
          const observerCurrentValue = (this.content.getValue() || '').trim()
          if (observerCurrentValue !== this.observerPreviousValue) {
            this.observerPreviousValue = observerCurrentValue
            this.$emit('typing', observerCurrentValue)
          }
        })
        this.observer.observe(this.$refs.vditor as Node, { childList: true, characterData: true, subtree: true })
      },
      input: (value: string) => {
        if (this.sourceEdit) {
          this.input(value)
        } else {
          this.$emit('input', value)
        }
      },
      ctrlEnter: (value: string) => {
        this.$emit('ctrl-enter', value)
      }
    }
  }

  created () {
    this.input = debounce(this.input, 1000)
  }

  mounted () {
    this.content = new Vditor(this.$refs.vditor as HTMLElement, this.options as IOptions)
  }

  beforeDestroy () {
    this.observer && this.observer.disconnect()
    try {
      this.content.destroy()
    } catch (e) {}
  }

  @Watch('value')
  update (value: string | undefined) {
    if (this.ready) {
      const editorValue = (this.content.getValue() || '').trim()
      const updateValue = (value || '').toString().trim()
      if (editorValue !== updateValue) {
        this.observerPreviousValue = updateValue
        this.content.setValue(updateValue)
      }
    }
  }

  @Watch('sourceEdit')
  sourceEditToggle (sourceEdit: boolean) {
    this.observer && this.observer.disconnect()
    this.content.destroy()
    this.content = new Vditor(this.$refs.vditor as HTMLElement, this.options as IOptions)
  }

  keydown (event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.$emit('enter', this.content.getValue(), event)
    }
  }

  input (value: string) {
    this.$emit('input', value)
  }

  focus () {
    this.focusable = true
    this.content.focus()
  }
}
